import { useEffect } from 'react';
import CookieBanner from './CookieBanner';
import { loadTracking } from '../lib/consent';

export default function ConsentManager() {
  useEffect(() => {
    if (localStorage.getItem('cookieConsent') === 'accepted') {
      loadTracking();
    }
  }, []);

  return <CookieBanner onAccept={loadTracking} onDecline={() => {}} />;
}
